
// let charlie = HELLO_WORLD;
// console.log(" HELLO WORLD  =", charlie);


// let apiKey= SERVER_API;
const apiKey= process.env.SERVER_API;
// let base= process.env.API_SERVER_URL;
const base= process.env.API_SERVER_URL;
// let base= "https://api.undersrory.community";
// let base= "https://api.usdev.fic.li";

// let base= "http://localhost:3030";
// console.log(" API SERVER URL  =", base);

// console.log(" SERVER API  =", apiKey);
async function send({ method, path, data }) {
    const opts = { method, headers: {'x-access-token': apiKey} };
    // console.log(" SERVER API  =", SERVER_API);
    if (data) {
        opts.headers["Content-Type"] = "application/json";
        opts.body = JSON.stringify(data);
    }

    const response = await fetch(`${base}${path}`, opts);
    const json = await response.text();
    var resParsed;
    try {
        resParsed = JSON.parse(json);
    } catch (e) {
        resParsed = {};
        resParsed.message = "";
        resParsed.errors = [];
    }
    if (response.status > 299) {
        return {
            code: response.status,
            message: resParsed.message,
            errors: resParsed.errors,
        };
    }
    try {
        return resParsed;
    } catch (err) {
        console.log("Error");
        return json;
    }
}

export function get(path) {
    return send({ method: "GET", path });
}
